import React from 'react';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import AppPageTemplate from './AppPageTemplate';
import { Outlet } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { themeProvider } from '../../themeProvider';
import { NavHeightProvider } from 'common/contexts/NavHeightContext';
import { useUserContext } from 'common/contexts/UserContext';
import _ from 'lodash';

const AppPageTemplateProvider = () => {
  const { user } = useUserContext();
  const LDClient = useLDClient();
  if (user && LDClient) {
    LDClient.identify({
      key: user.email,
      firstName: user.first_name,
      lastName: user.last_name,
      email: user.email,
      custom: {
        company: _.get(user, 'company.scac', null),
        pack: _.get(user, 'company.pack', null),
        companyType: _.get(user, 'company.type', null),
        isCompanyAdmin: _.get(user, 'is_admin', false),
      },
    });
  }
  return (
    <NavHeightProvider>
      <ThemeProvider theme={themeProvider}>
        <AppPageTemplate>
          <Outlet />
        </AppPageTemplate>
      </ThemeProvider>
    </NavHeightProvider>
  );
};

export default AppPageTemplateProvider;
